import React from 'react'
import { Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import { useTranslation } from 'react-i18next';

const ShowDeprecatedAddonPopup = (props) => {
    const { message, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    return (
        <View style={getStyles([""])}>
            <View style={getStyles([""])}>
                <Text style={getStyles([""])}>Attention</Text>
                <Text style={getStyles([""])}>{message}</Text>
            </View>

            <View style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleNext} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t("spaBooking.edit_reservation_button")}
                    </Text>
                </CustomPressable>

                <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>
                        {t("spaBooking.back")}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ShowDeprecatedAddonPopup
